<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Add Match Table</h4>
      </div>
      <div class="modal-body">
        <div class="form-group mb-3">
          <label>Name</label>
          <input class="form-control" [(ngModel)]="name" placeholder="Name" type="text">
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group mb-3">
              <label>Level Minimum Required</label>
              <input class="form-control" [(ngModel)]="levelMinimumRequired" placeholder="0" type="number">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-3">
              <label>Match Rank</label>
              <input class="form-control" [(ngModel)]="matchRank" placeholder="0" type="number">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group mb-3">
              <label>Match Cost</label>
              <input class="form-control" [(ngModel)]="matchCost" placeholder="0" type="number">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-3">
              <label>Variant ID</label>
              <input class="form-control" [(ngModel)]="variantId" placeholder="0" type="number">
            </div>
          </div>
        </div>
        <hr>
        <h6>Rewards</h6>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group mb-3">
              <label>XP Reward Quantity</label>
              <input class="form-control" [(ngModel)]="levelExperienceRewardQuantity" placeholder="0" type="number">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-3">
              <label>League Points Reward Quantity</label>
              <input class="form-control" [(ngModel)]="leaguePointRewardQuantity" placeholder="0" type="number">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group mb-3">
              <label>Credits Reward 1st</label>
              <input class="form-control" [(ngModel)]="creditRewardQuantity1" placeholder="0" type="number">
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-3">
              <label>Credits Reward 2nd</label>
              <input class="form-control" [(ngModel)]="creditRewardQuantity2" placeholder="0" type="number">
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-3">
              <label>Credits Reward (Draw)</label>
              <input class="form-control" [(ngModel)]="creditRewardQuantityDraw" placeholder="0" type="number">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group mb-3">
              <label>Hammer Reward Quantity</label>
              <input class="form-control" [(ngModel)]="hammerRewardQuantity" placeholder="0" type="number">
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="isLoading" type="button" class="btn btn-secondary" (click)="modal.hide()">Cancel</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="save()">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1"></span>
          Add
        </button>
      </div>
    </div>
  </div>
</div>
